export class FiltrosPropuestaOperacion {
    RucAdq: string = '';
    RucProv: string = '';
    Estado: string = 'P';
    TipoServicio: string = '0';
    FDesde: string = '';    
    FHasta: string = '';    
    user_id:string='';
}
